import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ITargetStatus } from "@/features/driver-status/driver-status.types";

interface IStatusProps {
  label: ITargetStatus;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomStatusBadge',
  props: {
    label: { default: "off" }
  },
  setup(__props: any) {

const props = __props;

const getBack = () => {
  if (props.label == "off") {
    return "#9b9daa";
  } else if (props.label == "sleep") {
    return "#f99e2c";
  } else if (props.label == "driving") {
    return "#27ae60";
  } else if (props.label == "on") {
    return "#409cff";
  } else if (props.label == "yard") {
    return "#409cff";
  } else if (props.label == "any") {
    return "#ffdfe3";
  } else {
    return "#9b9daa";
  }
};

const getLabel = () => {
  if (props.label == "off") {
    return "OFF";
  } else if (props.label == "sleep") {
    return "SB";
  } else if (props.label == "driving") {
    return "DR";
  } else if (props.label == "on") {
    return "ON";
  } else if (props.label == "yard") {
    return "YM";
  } else if (props.label == "personal") {
    return "PC";
  } else if (props.label == "any") {
    return "ANY";
  } else {
    return "NONE";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "c-cu-status-badge",
    style: _normalizeStyle({ background: getBack() })
  }, _toDisplayString(getLabel()), 5))
}
}

})